import React, { forwardRef } from 'react';

import type { TableFootProps } from './TableFoot';
import { TableFoot } from './TableFoot';
import { TableRow } from './TableRow';

export type TableFooterProps = TableFootProps;

export const TableFooter = forwardRef<HTMLDivElement, TableFooterProps>(
  ({ children, ...props }, ref) => {
    return (
      <TableFoot ref={ref} {...props}>
        <TableRow>{children}</TableRow>
      </TableFoot>
    );
  }
);
